var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('pt-adult-sell-order',{staticClass:"pt-adult-sell-order__withData"})}
var staticRenderFns = []

export { render, staticRenderFns }